import { useContext } from 'react'
import { PassContext } from "../../../pass-context"
import dataSelector from '../../data-selector'
import PopupEditor from '../../popup-editor'
import _ from 'lodash'

import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import SwapHorizIcon from '@mui/icons-material/SwapHoriz'

const GoogleHeader = () => {
  const { classData, objectData, instanceData, scannerInstanceData, passType } = useContext(PassContext)

  let header = getHeader({ classData, objectData, instanceData, scannerInstanceData, passType })
  let subheader = getSubHeader({ classData, objectData, instanceData, scannerInstanceData, passType })

  return (
    <div className="flex flex-col header">
      <SubHeader subheader={subheader} />
      <Header header={header} />
    </div>
  )
}

export default GoogleHeader


const Header = ({ header }) => {
  if (header.editable) {
    return (
      <PopupEditor title={header.title} path={header.path} sources={header.sources} required={true}>
        <div className="value editable">{header.value}</div>
      </PopupEditor>
    )
  } else {
    return (<div className="value">{header.value}</div>)
  }
}

const SubHeader = ({ subheader }) => {
  if (subheader.editable) {
    return (
      <PopupEditor title={subheader.title} path={subheader.path} sources={subheader.sources} type={subheader.type}>
        <div className="label editable">{subheader.value}</div>
      </PopupEditor>
    )
  } else {
    return (<div className="label">{subheader.value}</div>)
  }
}

const getHeader = ({ classData, objectData, instanceData, scannerInstanceData, passType }) => {
  try {
    switch (passType) {
      case "generic":
        {
          return {
            editable: true,
            sources: ["object"],
            path: "header.defaultValue.value",
            title: "Header",
            value: dataSelector({ objectData, instanceData, scannerInstanceData, path: "header.defaultValue.value" }) ?? ""// Mandatory
          }
        }

      case "eventTicket": {
        return {
          editable: true,
          sources: ["class"],
          path: "eventName.defaultValue.value",
          title: "Event Name",
          value: _.get(classData, "eventName.defaultValue.value") ?? "" // Mandatory
        }
      }

      case "flight":
        {
          return {
            editable: false,
            value: "" // Mandatory
          }
        }

      case "transit":
        {
          const { firstLeg, lastLeg } = getTransitLegs({ instanceData, scannerInstanceData })
          return {
            editable: false,
            value: <>{firstLeg.origin.code}<TransitIcon objectData={objectData} instanceData={instanceData} styles={{ fontSize: 50 }} />{lastLeg.destination.code}</>
          }
        }

      case "offer":
        {
          return {
            editable: true,
            sources: ["class"],
            path: "title.defaultValue.value",
            title: "Offer Title",
            value: _.get(classData, "title.defaultValue.value") ?? "" // Mandatory
          }
        }
      case "loyalty":
        {
          return {
            editable: true,
            sources: ["class"],
            path: "programName",
            title: "Program Name",
            value: _.get(classData, "programName") ?? ""  // Mandatory
          }
        }

      case "giftCard": {
        return {
          editable: true,
          sources: ["object"],
          path: "balance.micros",
          title: "Balance",
          value: getBalanceHeader({ objectData, instanceData, scannerInstanceData })
        }
      }
    }
  }
  catch (err) {
    console.error(err)
  }
}

const getSubHeader = ({ classData, objectData, instanceData, scannerInstanceData, passType }) => {
  try {
    switch (passType) {
      case "generic":
        {
          return {
            editable: true,
            sources: ["object"],
            path: "subheader.defaultValue.value",
            title: "Sub Header",
            value: dataSelector({ objectData, instanceData, scannerInstanceData, path: "subheader.defaultValue.value" }) ?? ""
          }
        }

      case "eventTicket": {
        return {
          editable: true,
          sources: ["class"],
          path: "venue.name.defaultValue.value",
          title: "Event Venue",
          value: _.get(classData, "venue.name.defaultValue.value") ?? "",
          type : "venue"
        }
      }

      case "flight":
        {
          return {
            editable: false,
            value: "" // Mandatory
          }
        }

      case "transit":
        {
          const { firstLeg, lastLeg } = getTransitLegs({ instanceData, scannerInstanceData })
          return {
            editable: false,
            value: `${firstLeg.origin.name} to ${lastLeg.destination.name}`
          }
        }

      case "offer":
        {
          // Not applicable
          return {
            editable: false
          }
        }
      case "loyalty":
        {
          // Not applicable
          return {
            editable: false
          }
        }

      case "giftCard": {
        // Not applicable!
        return {
          editable: false
        }
      }
    }
  }
  catch (err) {
    console.error(err)
  }
}


const getTransitLegs = ({ instanceData, scannerInstanceData }) => {

  let legs = instanceData.journey.legs

  const resolvedLegs = dataSelector({ objectData: { legs }, instanceData, scannerInstanceData, path: "legs" })

  let firstLeg = resolvedLegs[0]
  let lastLeg = resolvedLegs[resolvedLegs.length - 1]

  return ({ firstLeg, lastLeg })
}


const TransitIcon = ({ objectData, instanceData, scannerInstanceData, styles }) => {

  const tripType = dataSelector({ objectData, instanceData, scannerInstanceData, path: "tripType" })

  switch (tripType.toUpperCase()) {
    case "ONE_WAY": return <ArrowForwardIcon style={styles} />
    case "ROUND_TRIP": return <SwapHorizIcon style={styles} />
  }
}

const getBalanceHeader = ({ objectData, instanceData, scannerInstanceData }) => {
  const resolvedBalance = dataSelector({ objectData, instanceData, scannerInstanceData, path: "balance" })
  const microsString = Number(resolvedBalance.micros.toString().replace(/[^0-9.-]+/g,""));
  return "Gift Card: " + microsString.toLocaleString('en-US', { style: 'currency', currency: resolvedBalance.currencyCode, minimumFractionDigits: 0 })
}